var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999982 11.9999H2.99998V18.9999C2.99998 19.2651 3.10534 19.5195 3.29288 19.707C3.48041 19.8945 3.73477 19.9999 3.99998 19.9999H16C16.2652 19.9999 16.5196 19.8945 16.7071 19.707C16.8946 19.5195 17 19.2651 17 18.9999V11.9999H19C19.1932 12.0001 19.3824 11.9441 19.5445 11.8389C19.7065 11.7336 19.8346 11.5835 19.913 11.4069C19.9919 11.2304 20.0179 11.0347 19.9877 10.8437C19.9576 10.6526 19.8725 10.4745 19.743 10.3309L10.743 0.330904C10.364 -0.0910957 9.63598 -0.0910957 9.25698 0.330904L0.256982 10.3309C0.127673 10.4746 0.0427701 10.6526 0.012546 10.8435C-0.0176781 11.0344 0.00807238 11.23 0.0866816 11.4066C0.165291 11.5832 0.29339 11.7332 0.455477 11.8385C0.617565 11.9438 0.806696 11.9999 0.999982 11.9999ZM6.94898 11.6839C6.97998 11.7789 7.76198 13.9999 9.99998 13.9999C12.269 13.9999 13.042 11.7129 13.05 11.6889L14.95 12.3099C14.901 12.4609 13.703 15.9999 9.99998 15.9999C6.29698 15.9999 5.09898 12.4609 5.04998 12.3109L6.94898 11.6839Z",
    fill: "#A09E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d93ce2f652e226fe83e138ab46fb136f.svg";
export { ForwardRef as ReactComponent };